import { RuleGroupType } from "react-querybuilder"

import { Position } from "@costory/types/endpoints/digest"
import {
  BillyContributionAnalysisCategory,
  DatePreset,
} from "@costory/types/prisma-client"

import dayjs from "@costory/shared/dayjs"
import { getDigestPeriod } from "@costory/shared/utils/filters"

import { useContributionAnalysisAvailable } from "@costory/front/queries/billy"
import { useContributionAnalysisMutation } from "@costory/front/queries/digest"

export const useBilly = ({
  position,
  datePreset,
  period,
  exclusionWhereClause,
  costColumn,
}: {
  position: Position
  datePreset: DatePreset
  period: string
  exclusionWhereClause: RuleGroupType
  costColumn: string
}) => {
  const digestPeriod = getDigestPeriod(datePreset, dayjs(period))
  const historyOfCostsPeriod = {
    startDate: digestPeriod.previousStartDate.add(-1, "month"),
    endDate: digestPeriod.endDate,
  }
  const queryContributionAnalysis = useContributionAnalysisAvailable({
    previousStartDate: digestPeriod.previousStartDate,
    previousEndDate: digestPeriod.previousEndDate,
    startDate: digestPeriod.startDate,
    endDate: digestPeriod.endDate,
    exclusionWhereClause,
    costColumn,
    category: BillyContributionAnalysisCategory.CONTRIBUTION_ANALYSIS,
  })
  const queryHistoryOfCosts = useContributionAnalysisAvailable({
    previousStartDate: historyOfCostsPeriod.startDate,
    previousEndDate: historyOfCostsPeriod.endDate,
    startDate: historyOfCostsPeriod.startDate,
    endDate: historyOfCostsPeriod.endDate,
    exclusionWhereClause,
    costColumn,
    category: BillyContributionAnalysisCategory.HISTORY_OF_COSTS,
  })
  const mutationContributionAnalysis = useContributionAnalysisMutation({
    costColumn,
    whereClause: position,
    currentPeriod: {
      startDate: digestPeriod.startDate.toDate(),
      endDate: digestPeriod.endDate.toDate(),
    },
    previousPeriod: {
      startDate: digestPeriod.previousStartDate.toDate(),
      endDate: digestPeriod.previousEndDate.toDate(),
    },
    exclusionWhereClause,
    category: BillyContributionAnalysisCategory.CONTRIBUTION_ANALYSIS,
  })
  const mutationHistoryOfCosts = useContributionAnalysisMutation({
    costColumn,
    whereClause: position,
    currentPeriod: {
      startDate: historyOfCostsPeriod.startDate.toDate(),
      endDate: historyOfCostsPeriod.endDate.toDate(),
    },
    previousPeriod: {
      startDate: historyOfCostsPeriod.startDate.toDate(),
      endDate: historyOfCostsPeriod.endDate.toDate(),
    },
    exclusionWhereClause,
    category: BillyContributionAnalysisCategory.HISTORY_OF_COSTS,
  })
  return {
    queryContributionAnalysis,
    queryHistoryOfCosts,
    mutationContributionAnalysis,
    mutationHistoryOfCosts,
    digestPeriod,
  }
}
